import request from '@/utils/request';

/**
 * 托管轨静默初始化：Gas + dUSD approve(Exchange/FeeModule) + CT setApprovalForAll
 * POST /liyuan-evm-pm/pm-chain/privy/trading/ensure-ready
 *
 * @returns {Promise<{ address?: string, ready?: boolean, steps?: Array }>}
 */
export function postTradingEnsureReady() {
  // 后端 ensure-ready 含 custodial gas 轮询（≤8s）；须长于默认 axios 10s 全局 timeout 的边际场景
  return request.post('/liyuan-evm-pm/pm-chain/privy/trading/ensure-ready', {}, { timeout: 18000 });
}
